// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9cbb3923","239":"454ffe3c","455":"29f59ce3"}[chunkId] + ".chunk.js";
};